import { tss } from '@/shared/styles/tss'
export const useStyles = tss.withName('TransactionDrawer').create(() => ({
  drawer: {
    '& .MuiPaper-root': {
      borderTopLeftRadius: 16,
      borderTopRightRadius: 16,
      maxWidth: '100%',
      width: '100%',
      maxHeight: '90vh',
      background: 'rgba(29, 30, 34, 1)',
    },
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '8px',
    padding: '12px',
  },
  content: {
    padding: '12px',
  },
}))
